module.exports = __webpack_public_path__ + "static/media/icon-close.734a4fad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/spocketUI/components/select/images/icon-close.svg
// module id = 760
// module chunks = 0